import { render } from "./ScrollspyContent.vue?vue&type=template&id=825ee1f8"
import script from "./ScrollspyContent.vue?vue&type=script&lang=js"
export * from "./ScrollspyContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__